import pluralize from './pluralize.js';

// Plus is capped at PREMIUM_TIER_RESPONSE_LIMIT and free at
// FREE_TIER_RESPONSE_LIMIT in newspage-backend plans.constants.ts; the "10 a
// month" and "1 FREE" claims below track those two constants.
const PLUS_OR_PRO =
    'Upgrade to Newspage Plus for 10 responses a month or Newspage Pro for unlimited responses';
const PRO_ONLY = 'Upgrade to Newspage Pro for unlimited responses';

const getResponseUpgradeCopy = ({
    planType,
    totalResponses,
    hasUnlimitedResponses,
}) => {
    if (hasUnlimitedResponses) return null;
    if (planType !== 'free' && planType !== 'premium') return null;

    if (totalResponses <= 0) {
        return { variant: planType === 'free' ? 'free-wall' : 'limit-other' };
    }

    if (planType === 'premium') {
        return {
            variant: 'premium',
            lead: `You currently have ${totalResponses} ${pluralize(
                totalResponses,
                'response'
            )} left this month.`,
            cta: PRO_ONLY,
        };
    }

    // Only the untouched free allowance is "your 1 FREE response" — a free
    // member holding purchased credits has more than the plan grants.
    if (totalResponses === 1) {
        return {
            variant: 'free-last',
            lead: 'This will be your 1 FREE News Alert response this month.',
            cta: PLUS_OR_PRO,
        };
    }

    return {
        variant: 'free-credits',
        lead: `You currently have ${totalResponses} News Alert ${pluralize(
            totalResponses,
            'response'
        )} left.`,
        cta: PLUS_OR_PRO,
    };
};

export default getResponseUpgradeCopy;
